import * as React from "react";
import MuiRegularButton, { MuiRegularButtonProps } from "components/MuiExtras/Button/MuiRegularButton";
import IconCancel from "components/Icons/IconCancel";

const ButtonInputClear: React.FC<Omit<MuiRegularButtonProps, "simple" | "link" | "noPadding">> = (props) => {
    const { title, ...rest } = props;
    return (
        <MuiRegularButton
            {...rest}
            title={title || "Limpar"}
            simple={true}
            link={true}
            noPadding={true}
            noMargin={true}
        >
            <IconCancel fixedWidth />
        </MuiRegularButton>
    );
}
ButtonInputClear.defaultProps = {
    color: "transparent"
}

export default ButtonInputClear;
